import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { DiscordService } from '../../services/discord.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';

@Component({
    selector: 'app-airdrop-discord',
    templateUrl: './airdrop-discord.component.html',
    styleUrls: [ './airdrop-discord.component.scss' ]
})
export class AirdropDiscordComponent implements OnInit {
    @Input() task = {
        id: '',
        title: '',
        desc: '',
        icon: '',
        status: 'Pending',
        reward: 0,
        multiplier: false,
        redirect_url: '',
        cta: '',
        coming_soon: false
    };

    constructor(public httpService: HttpService,
        private discordService: DiscordService,
        private cfAlertService: CfAlertService
    ) {
        this.window = getWindow();
    }

    window: Window;

    public discord: any = {
        loading: false,
        loginButton: true,
        serverJoined: false,
        checkGroupButton: false,
        checkGroupJoinedIntervalId: null,
        accountConnected: false,
        groupCheckAttempt: 0,
        verifying_discord_joined: false
    };

    discordJoined: boolean = false;
    discord_join_loading: boolean = false;

    ngOnInit(): void {
        this.attachSocketEvents();
    }

    attachSocketEvents() {
        this.httpService.socket.on('discord_group_joined', (data: any) => {
            console.log('discord_group_joined socket => ', data);

            this.httpService.getCurrentUser();
        });
    }
    
    checkDiscordGroupJoined(showError: boolean, discord_url:string) {
        this.discordService.checkDiscordGroupJoined().subscribe((res) => {
            clearInterval(this.discord.checkGroupJoinedIntervalId);

            this.cfAlertService.showSuccess(res.message);
            
            this.window.location.href = discord_url;
        }, (err: HttpErrorResponse) => {
            console.error('checkDiscordGroupJoined error');
            console.error(err);
            console.log('error message', err.message);

            if (showError)
                this.cfAlertService.showError(err);

            this.discord.joinGroupLoading = false;
            this.discord.groupCheckAttempt++;

            console.log('this.discord.groupCheckAttempt', this.discord.groupCheckAttempt);

            if (this.discord.groupCheckAttempt > 10)
                clearInterval(this.discord.checkGroupJoinedIntervalId);

            this.window.location.href = discord_url;
        });
    }
    connectDiscord() {
        this.discord_join_loading = true;

        const body = {
            social_media_type: 'discord'
        };

        this.checkDiscordGroupJoined(true, this.task.redirect_url);
    }
}
